const NAMED_SIZES = { sm: 28, md: 32, lg: 40 };

export default function Logo({ withText = true, size = 32, className = '' }) {
  // Accept named sizes too: an SVG width of "sm" is invalid and renders the logo full-size.
  const iconSize = NAMED_SIZES[size] ?? (Number(size) || 32);
  return (
    <div className={`flex items-center gap-3 ${className}`.trim()} aria-label="Bench Bulletin logo">
      <svg
        width={iconSize}
        height={iconSize}
        viewBox="0 0 64 64"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
      >
        <rect width="64" height="64" rx="12" fill="#1a472a" />
        <g transform="translate(12,13)">
          <rect x="0" y="0" width="40" height="34" rx="5" fill="#ffffff" />
          <circle cx="6" cy="8" r="2.2" fill="#b45309" />
          <rect x="11" y="6" width="24" height="3.5" rx="1.75" fill="#1a472a" />
          <rect x="6" y="13" width="28" height="3.5" rx="1.75" fill="#1a472a" opacity="0.9" />
          <rect x="6" y="20" width="24" height="3.5" rx="1.75" fill="#1a472a" opacity="0.85" />
        </g>
      </svg>
      {withText && (
        <span className="font-heading text-xl font-bold text-brand-green leading-none select-none">
          Bench Bulletin
        </span>
      )}
    </div>
  );
}


